import React, { Component } from "react";
import { HashLink } from "react-router-hash-link";
import profile from "../../../assets/profile.png";
import { NavItems } from "./NavItems";

export default class Navbar extends Component {
  state = { active: false };

  handleClick = () => {
    this.setState({ active: !this.state.active });
  };

  render() {
    return (
      <nav className={this.state.active ? "navbar open" : "navbar"}>
        <a className="navbar__brand" href="/">
          <img className="navbar__brand__img" src={profile} alt="Profile" />
        </a>
        <div className="navbar__icon" onClick={this.handleClick}>
          <i
            className={
              this.state.active
                ? "ri-close-line nav-icon"
                : "ri-menu-3-line nav-icon"
            }
          ></i>
        </div>
        <ul
          className={this.state.active ? "navbar__menu active" : "navbar__menu"}
        >
          {NavItems.map((item, index) => {
            return (
              <li className="navbar__menu__link" key={index}>
                <a
                  className={item.cName}
                  href={item.url}
                  onClick={this.handleClick}
                >
                  {item.title}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}
